import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAppStore = defineStore('app', () => {
  const contactDetailId = ref<number>(0);
  const fallbackCoordinates = ref<number[]>([]);
  const showInternalInformation = ref<boolean>(false);

  return { contactDetailId, showInternalInformation, fallbackCoordinates };
});
